import backendApiService from "../service/backend-api.service";

export async function fetchOtherStoreList() {
  const data = await backendApiService.getOtherStoreList();
  return data.stores ?? [];
}

export async function fetchOtherStore(storeId) {
  const data = await backendApiService.getOtherStore(storeId);
  return data.store ?? null;
}

export async function fetchOtherStoreUiConfig() {
  const data = await backendApiService.getOtherStoreUiConfig();
  return data;
}

export async function checkoutOtherStore(storeId, payload) {
  return backendApiService.checkoutOtherStore(storeId, payload);
}

export async function fetchOtherStoreOrder(orderId, { accessToken } = {}) {
  const data = await backendApiService.getOtherStoreOrder(orderId, {
    accessToken,
  });
  return data.order ?? null;
}

export async function trackReferralVisit(refCode) {
  const data = await backendApiService.trackReferralVisit(refCode);
  return data;
}
